import Grid from '@material-ui/core/Grid';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Stepper from '@material-ui/core/Stepper';
import CancelIcon from '@material-ui/icons/Cancel';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import React, { useEffect, useState } from 'react';
import { useObservable } from 'react-use-observable';
import { ERequestStatus } from 'v2/interfaces/shopping';
import { refundRequestFactory } from 'v2/services/shopping/refundRequest';
import { dateService } from 'v2/services/date';

import type { IRefundRequest, IShoppingProduct } from 'v2/interfaces/shopping';

const RefundStatus = ({ shopping }: { shopping: IShoppingProduct }) => {
  const [refundRequest] = useObservable<IRefundRequest>(() => refundRequestFactory.buyerFindRefundByInvoiceId(shopping.invoice_id), []);
  const [refundMessage, setRefundMessage] = useState<boolean>(false);
  const [approvedMessage, setApproveMessage] = useState<boolean>(false);
  const [reprovedMessage, setReprovedMessage] = useState<boolean>(false);

  useEffect(() => {
    setRefundMessage(refundRequest?.status == ERequestStatus.PENDING);
    setApproveMessage(refundRequest?.status == ERequestStatus.APPROVED);
    setReprovedMessage(refundRequest?.status == ERequestStatus.REPROVED);
  }, [refundRequest]);

  const isThereAMessage = refundMessage || approvedMessage || reprovedMessage;

  if (!isThereAMessage) return null;

  return (
    <>
      <Grid container justify='space-around' spacing={1}>
        <div className='m8'></div>
        <Stepper activeStep={2} orientation='vertical'>
          {(refundMessage || approvedMessage || reprovedMessage) && (
            <Step key={1}>
              <StepLabel icon={<CheckCircleOutlineIcon />}>
                Seu reembolso foi solicitado e aguarda aprovação do produtor - {
                  dateService.dateToString(new Date(refundRequest?.requested_at), 'dd/MM/yyyy HH:mm')
                }
              </StepLabel>
            </Step>
          )}

          {approvedMessage && (
            <Step key={2}>
              <StepLabel icon={<CheckCircleIcon color='secondary' />}>Seu reembolso foi aprovado pelo produtor.</StepLabel>
            </Step>
          )}

          {reprovedMessage && (
            <Step key={3}>
              <StepLabel icon={<CancelIcon color='error' />}>
                Seu reembolso foi reprovado pelo produtor. Motivo: {refundRequest?.justification}
              </StepLabel>
            </Step>
          )}
        </Stepper>
      </Grid>
    </>
  );
};

export default RefundStatus;
